import script from "./GetInTouch.vue?vue&type=script&setup=true&lang=js"
export * from "./GetInTouch.vue?vue&type=script&setup=true&lang=js"

import "./GetInTouch.vue?vue&type=style&index=0&id=c2408180&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2408180"]])

export default __exports__